import BusinessList from '@/components/Business/BusinessList'
import BusinessForm from '@/components/Business/BusinessForm'
import BusinessDetail from '@/components/Business/BusinessDetail'

let BusinessRouter = [{
  path: '/business',
  name: 'BusinessList',
  component: BusinessList,
  meta: {
    title: 'Affaires',
    requiresAuth: true,
    authorizations: ['business_index', 'desktop_access']
  }
}, {
  path: '/business/new',
  name: 'BusinessNew',
  component: BusinessForm,
  meta: {
    title: 'Nouvelle affaire',
    requiresAuth: true,
    authorizations: ['business_new', 'desktop_access']
  }
}, {
  path: '/business/:id/edit',
  name: 'BusinessEdit',
  component: BusinessForm,
  meta: {
    title: 'Modifier une affaire',
    requiresAuth: true,
    authorizations: ['business_edit', 'desktop_access']
  }
}, {
  path: '/business/:id',
  name: 'BusinessDetail',
  component: BusinessDetail,
  meta: {
    title: 'Fiche affaire',
    requiresAuth: true,
    authorizations: ['business_show', 'desktop_access']
  }
}]

export default BusinessRouter



// WEBPACK FOOTER //
// ./src/components/Business/router.js